export const VERTICALS = [
  {
    id: 1,
    key: "glazing",
    label: "Glazing",
  },
  {
    id: 3,
    key: "lixil",
    label: "Lixil",
  },
  {
    id: 2,
    key: "hunter_douglas",
    label: "Hunter Douglas",
  },
];
